<template>
  <div class="text-center">
    <v-avatar size="100" color="success">
      <v-icon size="80">mdi-check</v-icon>
    </v-avatar>
    <div class="mt-5" data-testid="success-status-message">{{ message }}</div>
    <p v-if="subtitle" class="mt-1 text-medium-emphasis">{{ subtitle }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  message: string;
  subtitle?: string;
}>();
</script>
